import './TimelineItem.css';

function TimelineItem({ children }) {
    return (
        <li className='TimelineItem'>{children}</li>
    );
}

export default TimelineItem;